import type {StyleBlockStateType} from '@packages/shared/LegacyStyleSystem/states/StyleBlockStateTypes';

/**
 * Makes a fake StyleBlock real.
 */
export function reifyStyleBlock(
  state: StyleBlockStateType,
  {
    _id,
  }: {
    _id: string;
  },
  isBranchMode?: boolean
): StyleBlockStateType {
  return state
    .resetChangedRule()
    .resetAddedRule()
    .update('styleBlocks', (styleBlocks) => {
      return styleBlocks.setIn([_id, 'fake'], false);
    })
    .update('styleBlockIds', (styleBlockIds) => {
      // Until we can merge style blocks from branches into the main site, do not reify tags on branches
      if (isBranchMode) {
        return styleBlockIds;
      }
      return styleBlockIds.add(_id);
    });
}
